import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Cloudinfrarange() {
  return (
    <section
      className="cloud_infra_range p-100"
      style={{ background: "#F8F8FB" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>Our Range of Cloud Infrastructure Management Services</h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              We’re committed to creating scalable and adaptable cloud
              infrastructure solutions that help businesses prosper in the
              quickly changing digital environment. We provide cutting-edge
              cloud and infrastructure solutions to companies trying to save
              expenses and boost productivity. Here are the cloud infrastructure
              services we offer:
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="range_cloud_box">
                  <div className="range_cloud_main">
                    <div className="range_cloud_num">
                      <h5>01</h5>
                    </div>
                    <div className="range_cloud_heading">
                      <h4>Identity & Access Management (IAM)</h4>
                    </div>
                  </div>
                  <div className="range_cloud_content">
                    <p>
                      Securely manage user identities and control resource
                      access with detailed and instant permissions. We go beyond
                      simple logins and multi-factor authentication (MFA) to
                      offer advanced user provisioning, role-based access
                      control (RBAC), and single sign-on (SSO) to control user
                      access to cloud resources and sensitive data.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="range_cloud_box">
                  <div className="range_cloud_main">
                    <div className="range_cloud_num">
                      <h5>02</h5>
                    </div>
                    <div className="range_cloud_heading">
                      <h4>
                        Multi-Cloud
                        <br /> Management
                      </h4>
                    </div>
                  </div>
                  <div className="range_cloud_content">
                    <p>
                      As a leading cloud infrastructure company, we help you
                      manage multiple cloud environments through unified
                      management and workload mobility. Our solutions reduce
                      complexity and boost flexibility, facilitating flawless
                      workload migration across various cloud providers.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="range_cloud_box">
                  <div className="range_cloud_main">
                    <div className="range_cloud_num">
                      <h5>03</h5>
                    </div>
                    <div className="range_cloud_heading">
                      <h4>
                        Cloud File & Storage
                        <br /> Services
                      </h4>
                    </div>
                  </div>
                  <div className="range_cloud_content">
                    <p>
                      With our cloud infrastructure management services,
                      businesses can securely store, manage, and share files. We
                      offer high availability through automatic backups and
                      enable continuous collaboration across teams, even when
                      they are spread across different locations.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="range_cloud_box">
                  <div className="range_cloud_main">
                    <div className="range_cloud_num">
                      <h5>04</h5>
                    </div>
                    <div className="range_cloud_heading">
                      <h4>
                        Cloud
                        <br /> Administrations
                      </h4>
                    </div>
                  </div>
                  <div className="range_cloud_content">
                    <p>
                      We provide complete solutions for managing the whole cloud
                      lifecycle from licensing and onboarding to spending
                      monitoring, IT management, and offboarding. Our services
                      ensure that your organization's cloud journey remains
                      well-managed, cost-optimized, and secure in the cloud.
                    </p>
                  </div>
                </div>
              </Col>

              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="range_cloud_box">
                  <div className="range_cloud_main">
                    <div className="range_cloud_num">
                      <h5>05</h5>
                    </div>
                    <div className="range_cloud_heading">
                      <h4>
                        Virtual Private Cloud <br /> Servers & Networks
                      </h4>
                    </div>
                  </div>
                  <div className="range_cloud_content">
                    <p>
                      We establish isolated virtual private cloud environments
                      with specialized resources. Our VP cloud servers provide
                      high security, configurable network settings, and scalable
                      infrastructure to successfully meet your business's
                      evolving requirements.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="range_cloud_box">
                  <div className="range_cloud_main">
                    <div className="range_cloud_num">
                      <h5>06</h5>
                    </div>
                    <div className="range_cloud_heading">
                      <h4>
                        Cloud Security <br /> Enhancement
                      </h4>
                    </div>
                  </div>
                  <div className="range_cloud_content">
                    <p>
                      We preserve your data by using strong security measures
                      and real-time threat detection processes. By significantly
                      lowering security incidents by 40%, our solutions not only
                      meet but surpass industry requirements. Our security
                      solutions, guarantee the integrity of your data so you can
                      confidently concentrate on your main business operations.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="range_cloud_box">
                  <div className="range_cloud_main">
                    <div className="range_cloud_num">
                      <h5>07</h5>
                    </div>
                    <div className="range_cloud_heading">
                      <h4>
                        Disaster <br /> Recovery
                      </h4>
                    </div>
                  </div>
                  <div className="range_cloud_content">
                    <p>
                      We implemented strong disaster recovery strategies that
                      include data replication and automatic failover. With the
                      help of these techniques, your systems will be able to
                      recover in less than 15 minutes, a shorter amount of time
                      than most industry standards.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="range_cloud_box">
                  <div className="range_cloud_main">
                    <div className="range_cloud_num">
                      <h5>08</h5>
                    </div>
                    <div className="range_cloud_heading">
                      <h4>
                        Cloud Print <br /> Services
                      </h4>
                    </div>
                  </div>
                  <div className="range_cloud_content">
                    <p>
                      Our managed cloud print services are conveniently
                      available from any device at any location. We ensure
                      efficient printing processes that are customized to your
                      specific requirements, in conjunction with supply
                      management and field service solutions.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Cloudinfrarange;
